/* esm.sh - is-plain-obj@4.1.0 */
function e(t){if(typeof t!="object"||t===null)return!1;let o=Object.getPrototypeOf(t);return(o===null||o===Object.prototype||Object.getPrototypeOf(o)===null)&&!(Symbol.toStringTag in t)&&!(Symbol.iterator in t)}export{e as default};
//# sourceMappingURL=is-plain-obj.mjs.map